import React, { useState, FormEvent, useContext, useEffect } from "react";
import { Segment, Form, Button } from "semantic-ui-react";
import { IWarehouse } from "../../../app/models/warehouse";
import { v4 as uuid } from "uuid";
import WarehouseStore from "../../../app/stores/warehouseStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";

const WarehouseCreateForm: React.FC<RouteComponentProps> = ({
  match,
  history,
}) => {
  const warehouseStore = useContext(WarehouseStore);
  const {
    createWarehouse,
    submitting,
    warehouse: initialFormState,
  } = warehouseStore;

  const [warehouse, setWarehouse] = useState<IWarehouse>({
    id: "",
    createdAt: "",
    updatedAt: "",
    partNo: "",
    name: "",
    stock: 0,
    price: 0,
    projectType: "",
    description: "",
    supplier: "",
    url: "",
  });

  const type = [
    { key: "BDOD", text: "BDOD", value: "BDOD" },
    {
      key: "5G Transmission",
      text: "5G Transmission",
      value: "5G Transmission",
    },
  ];

  const handleSubmit = () => {
    if (warehouse.partNo==="") {
      setWarehouse({...warehouse, partNo: "N/A"});
    }
    createWarehouse(warehouse).then(() =>
      history.push(`/dailymanagement/warehouse`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setWarehouse({ ...warehouse, [name]: value });
  };

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Input
          label="PartNo"
          onChange={handleInputChange}
          name="partNo"
          placeholder="PartNo"
          value={warehouse.partNo}
        />
        <Form.Input
          label="Name"
          required
          onChange={handleInputChange}
          name="name"
          placeholder="Name"
          value={warehouse.name}
        />
        <Form.Input
          label="Stock"
          onChange={handleInputChange}
          name="stock"
          placeholder="Stock"
          value={warehouse.stock}
        />
        <Form.Input
          label="Price"
          onChange={handleInputChange}
          name="price"
          placeholder="Price"
          value={warehouse.price}
        />
        <Form.Select
            label="Project Type"
            required
            onChange={(e, { name, value }) =>
              setWarehouse({ ...warehouse, [name]: value })
            }
            width="8"
            name="projectType"
            placeholder="Project Type"
            options={type}
            value={warehouse.projectType}
          />
        <Form.Input
          label="Description"
          onChange={handleInputChange}
          name="description"
          placeholder="Description"
          value={warehouse.description}
        />
        <Form.Input
          label="Supplier"
          onChange={handleInputChange}
          name="supplier"
          placeholder="Supplier"
          value={warehouse.supplier}
        />
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/dailymanagement/warehouse")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(WarehouseCreateForm);
